import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateTime } from 'luxon';

import { SharedModule } from '@/app/shared/shared.module';
import { DkGalleryGroup, DkGalleryItem } from './dk-image-gallery.types';

@Component({
  selector: 'dk-image-gallery',
  imports: [SharedModule],
  templateUrl: './dk-image-gallery.component.html',
  styleUrl: './dk-image-gallery.component.less',
})
export class DkImageGalleryComponent {
  @Input() groups: DkGalleryGroup[] = [];
  @Input() titleKey = 'doktar_app.common.gallery_title';
  @Input() periodStart?: DateTime;
  @Input() periodEnd?: DateTime;
  @Input() captionKey = 'doktar_app.common.showing_most_recent_to_oldest';
  @Input() hasMore = false;
  @Input() isLoadingMore = false;
  @Input() emptyMessageKey = '';
  @Input() clearActionKey = '';

  @Output() back = new EventEmitter<void>();
  @Output() loadMore = new EventEmitter<void>();
  @Output() changePeriod = new EventEmitter<void>();
  @Output() clearPeriod = new EventEmitter<void>();
  @Output() itemSelected = new EventEmitter<DkGalleryItem>();

  readonly brokenImageIds = new Set<string>();

  markImageAsBroken(id: string): void {
    this.brokenImageIds.add(id);
  }
}
